import { AssetImage } from "@/components/site/AssetImage";
import { HeroSnow } from "@/components/site/HeroSnow";

export const BannerLine = () => (
  <p className="relative bg-[#24453D] py-2 text-center text-xs font-semibold tracking-wide text-[#FFF3D6] sm:text-sm" data-testid="banner-line">
    Awareness equals Funding equals Research equals A Cure
  </p>
);

export function GlowPhoto({ testId, iconTestId, eager = true }) {
  return (
    <div className="relative mx-auto w-full max-w-[220px] sm:max-w-[320px] lg:max-w-[380px]">
      <div className="of-glow-breathe absolute -inset-10 rounded-full bg-[radial-gradient(circle,rgba(245,174,61,0.38)_0%,rgba(243,175,194,0.3)_45%,transparent_72%)]" aria-hidden />
      <AssetImage asset="OLIVIA_HERO" size="lg" eager={eager} sizes="(min-width: 1024px) 380px, (min-width: 640px) 320px, 220px" className="of-photo-glow relative aspect-[3/4] w-full rounded-[36px]" testId={testId} />
      {iconTestId && <AssetImage asset="ICON" size="xs" className="absolute -left-4 -top-4 h-16 w-16 rotate-[-8deg] rounded-2xl shadow-md sm:-left-6 sm:-top-6 sm:h-24 sm:w-24" testId={iconTestId} />}
    </div>
  );
}

export function FestiveHero({ labelledBy, bg, children, photo, testId, banner = false }) {
  return (
    <section aria-labelledby={labelledBy} className="relative flex min-h-[calc(100svh-72px)] flex-col overflow-hidden" style={{ background: bg }} data-testid={testId}>
      <HeroSnow />
      {banner && <BannerLine />}
      <div className="of-container relative grid flex-1 items-center gap-8 py-8 sm:py-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16">
        <div>{children}</div>
        {photo}
      </div>
    </section>
  );
}
